import { z } from "zod/v4";

import { S3FileLocationDtoSchema } from "../../../dtos/s3-file-location";

export const GetTabularProductsRequestBodySchema = S3FileLocationDtoSchema;

export type GetTabularProductsRequestBodyType = z.infer<
  typeof GetTabularProductsRequestBodySchema
>;

export const GetTabularProductsResponseBodySchema = z
  .object({
    bucket: S3FileLocationDtoSchema,
    variations: z.string().array(),
  })
  .nullish();

export type GetTabularProductsResponseBodyType = z.infer<
  typeof GetTabularProductsResponseBodySchema
>;
